import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from '@/components/Button';
import Dialog, {
	DialogContent,
	DialogFooter,
	DialogTop
} from '@/components/Dialog';
import Cancel from '@/icons/cancel-subscription.svg';
import { cancelSubscription } from '@/store/billing/thunks';
import { fetchBillingInfo } from '@/store/profile/thunks';
import { showError } from '@/utils';

function CancelSubscriptions({ open, onOpenChange }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	const handleCancelSubscriptions = async () => {
		try {
			setLoading(true);
			await dispatch(cancelSubscription()).unwrap();
			await dispatch(fetchBillingInfo()).unwrap();

			onOpenChange(false);
		} catch (err) {
			showError(err);
		}
		setLoading(false);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="w-[280px] md:w-[397px]">
				<DialogTop
					title={t('billing.modals.cancelSubscription.title')}
					description={t('billing.modals.cancelSubscription.description')}
				/>

				<div className="flex flex-col items-center gap-2 px-4 py-9">
					<Cancel />
					<p className="whitespace-pre-line text-center text-sm text-grey-500">
						{t('billing.modals.cancelSubscription.text')}
					</p>
				</div>
				<DialogFooter>
					<Button variant="outline" onClick={() => onOpenChange(false)}>
						{t('common.close')}
					</Button>
					<Button
						onClick={() => handleCancelSubscriptions()}
						loading={loading}
					>
						{t('billing.modals.cancelSubscription.yesCancel')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default CancelSubscriptions;
